import { useState } from "react";
import { emitMascotEvent } from "@/features/mascot/mascotBus";

const SLOTS = [
  { t: "9:00 am",  state: "available" },
  { t: "9:30 am",  state: "available" },
  { t: "10:00 am", state: "picked" },
  { t: "10:30 am", state: "taken" },
  { t: "11:00 am", state: "available" },
  { t: "11:30 am", state: "available" },
] as const;

export function SlotStrip() {
  // 10:00 am stays selected. It cycled through the available slots on a timer for a while,
  // which read as the page choosing for you rather than as a demo; the strip only changes
  // now when a visitor actually clicks one.
  const [picked, setPicked] = useState(2);

  return (
    <div className="lp-slot-row" role="list">
      {SLOTS.map((s, i) => {
        const isTaken = s.state === "taken";
        const isPicked = i === picked;
        const cls = ["lp-slot", isPicked ? "picked" : isTaken ? "taken" : ""].filter(Boolean).join(" ");
        return (
          <button
            key={i}
            role="listitem"
            className={cls}
            /* The mobile hero shows the first four, which still cover all three
               states (available / picked / taken); 11:00 and 11:30 are further
               plain-available repeats that only add height. See
               .lp-slot[data-slot] in landing.css — desktop shows all six. */
            data-slot={i}
            disabled={isTaken}
            onClick={() => {
              if (isTaken) return;
              setPicked(i);
              // The hero mascot acknowledges a real interaction with the demo.
              emitMascotEvent("demo-slot-picked");
            }}
            aria-label={`${s.t}${isTaken ? " - unavailable" : ""}`}
          >
            {s.t}
          </button>
        );
      })}
    </div>
  );
}
